module.exports = __webpack_public_path__ + "img/active-guest-w.svg";